module.exports = __webpack_public_path__ + "media/img/pages/companies/switch-b8973593d73de8d7c0ef2d795fa03ef4.png";